import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import {CountrySelectorService} from './country-selector.service';

export type EmbargoCountryList = {
  countries: {
    country: string;
    country_code: string;
    region_code: string;
  }[];
};

@Injectable({
  providedIn: 'root'
})
export class GeolocationService {

  public static readonly akamaiEdgeHeader: string = 'X-Akamai-Edgescape';

  constructor(
    private http: HttpClient,
    private countrySelectorService: CountrySelectorService,
  ) {
  }

  static extractCountryISOFromAkamaiHeader(akamaiHeaderContent: string): string {
    if (!akamaiHeaderContent) {
      return '';
    } else {
      const indexOfCountryISO = akamaiHeaderContent.indexOf('country_code');
      if (indexOfCountryISO === -1) {
        return '';
      }
      let countryPart = akamaiHeaderContent.substring(indexOfCountryISO);
      countryPart = countryPart.substring(0, countryPart.indexOf(','));
      return countryPart?.split('=')?.[1];
    }
  }

  static extractRegionISOFromAkamaiHeader(akamaiHeaderContent: string): string {
    if (!akamaiHeaderContent) {
      return '';
    } else {
      const indexOfRegionISO = akamaiHeaderContent.indexOf('region_code');
      if (indexOfRegionISO === -1) {
        return '';
      }
      let regionPart = akamaiHeaderContent.substring(indexOfRegionISO);
      regionPart = regionPart.substring(0, regionPart.indexOf(','));
      return regionPart?.split('=')?.[1];
    }
  }

  static isBlockedGeolocation(
    embargoList: EmbargoCountryList,
    currentCountry: string,
    currentRegion: string,
  ): boolean {
    const matchingBlockEntryIndex = embargoList.countries.findIndex((item) => {
      if (item.country_code && item.region_code) {
        return item.country_code === currentCountry && item.region_code === currentRegion;
      } else {
        return item.country_code === currentCountry || item.region_code === currentRegion;
      }
    });
    return matchingBlockEntryIndex > -1;
  }

  getGeolocation(): Observable<any> {
    const route = location.origin.toLowerCase();
    if (!route.includes('localhost')) {
      return this.http.get<any>('/geolocation');
    } else {
      const countryIso = this.countrySelectorService.getCurrentCountry().isocode;
      return of({
        country_code: countryIso,
        region_code: '',
        embargo: false,
      });
    }
  }
}
